<template>
    <a href="https://ascenti.co.uk" class="ascenti-logo" :class="{'ascenti-logo--white': theme !== 'light' }">
        Ascenti
    </a>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState('header', ['theme'])
        },
    }
</script>
